import { In } from 'typeorm'

import { Role } from '@things-factory/auth-base'
import { Activity } from '@things-factory/worklist'
import { issue } from '@things-factory/worklist/dist-server/controllers/activity-instance/issue'

import { DataSet } from '../service/data-set/data-set.js'
import { DataOoc } from '../service/data-ooc/data-ooc.js'

export async function issueOocReview(dataOoc: DataOoc, dataSet: DataSet, context: ResolverContext): Promise<void> {
  const { domain, tx } = context.state
  const { collectedAt } = dataOoc

  var activities = await tx.getRepository(Activity).find({
    where: {
      domain: domain.parentId ? In([domain.id, domain.parentId]) : { id: domain.id },
      name: 'OOC Review'
    }
  })

  var activity = activities.find(a => a.domainId === domain.id) || activities.find(a => a.domainId === domain.parentId)

  if (activity) {
    const assigneeRole =
      dataSet.supervisoryRoleId &&
      (await tx.getRepository(Role).findOneBy({
        domain: { id: In([domain.id, domain.parentId].filter(Boolean)) },
        id: dataSet.supervisoryRoleId
      }))

    if (assigneeRole) {
      const activityInstance = {
        name: `[OOC 검토] ${dataSet.name}`,
        description: dataSet.description,
        activityId: activity.id,
        dueAt: new Date(collectedAt.getTime() + (activity.standardTime || 24 * 60 * 60) * 1000),
        input: {
          dataOocId: dataOoc.id
        },
        assigneeRole,
        threadsMin: 1,
        threadsMax: 1,
        approvalLine: []
      }

      const reviewActivityInstance = await issue(activityInstance as any, context)
      await tx.getRepository(DataOoc).update({ id: dataOoc.id }, { reviewActivityInstance })
    } else {
      console.error(
        `Assignees are not set. So Data OOC Review task for ${dataOoc.name}(${dataOoc.id}) could not be issued.`
      )
    }
  } else {
    console.warn('OOC Review Activity not installed.')
  }
}
